/* RESPONSIBLE TEAM: team-conversations */
const REFERENCES_ONE = 'references_one';
const REFERENCES_MANY = 'references_many';

export { REFERENCES_ONE, REFERENCES_MANY };
